<template>
  <div class="review-rate">
    <div class="review-rate__likes review__item-meta text-disabled">
      <span class="review__item-meta" dir="ltr">
        <i class="review-rate__likes-icon material-icons">
          thumb_up
        </i>
        {{ likes }}
      </span>
      <span class="review__item-meta" dir="ltr">
        <i class="review-rate__likes-icon material-icons">
          thumb_down
        </i>
        {{ dislikes }}
      </span>
    </div>
    <ElRate
      v-model="rate"
      class="review__item-meta"
      disabled
      text-color="#ff9900"
    />
  </div>
</template>

<script>
export default {
  name: 'ReviewRate',

  props: {
    rate: {
      type: Number,
      default: 0,
    },
    likes: {
      type: Number,
      default: 0,
    },
    dislikes: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
.review-rate {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;

  &__likes {
    &,
    &-icon {
      font-size: 90%;
    }

    @include breakpoint(medium) {
      font-size: 100%;
    }
  }

  .el-rate {
    display: inline-block;

    &__item {
      vertical-align: middle;
    }

    &__icon {
      margin-right: 0;
      margin-left: 6px;
      font-size: rem-calc(14);

      @include rtl() {
        margin-left: 0;
        margin-right: 6px;
      }
    }
  }

  @include breakpoint(medium) {
    flex-direction: row;
    align-items: center;
  }
}
</style>
